import type { ActionSource } from './ActionSource';
type CommandingViewActionSource = 'SimplifiedRibbon' | 'MultiLineRibbon';

export default CommandingViewActionSource;

export function isCommandingViewActionSource(actionSource: ActionSource): boolean {
    return actionSource === 'SimplifiedRibbon' || actionSource === 'MultiLineRibbon';
}
